import React from 'react';
import { Modal } from 'antd';
import { Button } from '../../../components/ui';
import { useSyncDedicatedIp } from '../../../mutation/dedicatedIp';

export default function SyncDedicatedIpButton() {
  const { mutate, isLoading } = useSyncDedicatedIp();
  return (
    <Button
      disabled={isLoading}
      loading={isLoading}
      type="button"
      onClick={() =>
        Modal.confirm({
          onOk: () => {
            mutate();
            return false;
          },
          title: 'Do you want to get IPs from ESPs?',
          content: 'Some ESP needs IPs to be manually input',
        })
      }
    >
      Sync from ESPs
    </Button>
  );
}
